export default {"src":"/_next/static/media/carousel-arrow-left.0c4f3d2f.svg","height":42,"width":42};